module.exports = __webpack_public_path__ + "img/bird-window.00142c18.png";